'use client';

import { SortSheet, type SortFieldOption } from '@paeffgen/react/crm-documents/ui';

export interface SortConfig {
  key: string;
  direction: 'asc' | 'desc';
}

const SORT_OPTIONS: SortFieldOption[] = [
  { id: 'date', label: 'Datum', ascSub: 'Älteste zuerst', descSub: 'Neueste zuerst' },
  { id: 'number', label: 'Belegnummer', ascSub: 'A → Z', descSub: 'Z → A' },
  { id: 'netTotal', label: 'Betrag', ascSub: 'Niedrigster zuerst', descSub: 'Höchster zuerst' },
  { id: 'commission', label: 'Kommission', ascSub: 'A → Z', descSub: 'Z → A' },
];

interface BelegeSortSheetProps {
  open: boolean;
  onClose: () => void;
  sortConfig: SortConfig;
  onSortChange: (next: SortConfig) => void;
}

export function BelegeSortSheet({
  open,
  onClose,
  sortConfig,
  onSortChange,
}: BelegeSortSheetProps) {
  return (
    <SortSheet
      open={open}
      onClose={onClose}
      title="Sortieren"
      options={SORT_OPTIONS}
      sortKey={sortConfig.key}
      sortDir={sortConfig.direction}
      onChangeSortKey={(key) => onSortChange({ ...sortConfig, key })}
      onChangeSortDir={(direction) => onSortChange({ ...sortConfig, direction })}
    />
  );
}
